import { render, staticRenderFns } from "./TypeDetail.vue?vue&type=template&id=31793a50&"
import script from "./TypeDetail.vue?vue&type=script&lang=js&"
export * from "./TypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports